/* eslint-disable no-case-declarations */
import { ICommonQuery } from '@Models/common.model'
import axios, { AxiosError, AxiosResponse } from 'axios'
import * as _ from 'lodash'
import * as Redux from 'redux'
import { EAuthReground } from '../../enum/auth.enum'
import { MCity, MCountry, MState, RegroundTypes } from '../../models/auth.model'
import { APIServices } from '../../services/api.service'
import { ToastServices } from '../../services/toast.service'
import { AuthActionTypes } from './auth.action-types'

const authUrl = `${APIServices.authUrl}/auth`
const REGROUND = `${APIServices.apiUrlV1}/reground`

const setLoading = (isLoading: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: AuthActionTypes.SET_GLOBAL_LOADING,
            payload: isLoading,
        })
    }
}

const setRegister = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({ type: AuthActionTypes.SET_REGISTER, payload })
    }
}

const getAuthorization = () => {
    return (dispatch: Redux.Dispatch) => {
        const { clientId, authorizeHeader } = APIServices
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${authUrl}/authorize`,
                    { clientId },
                    { headers: authorizeHeader() }
                )
                .then((response) => {
                    const payload = response?.data?.token
                    dispatch({
                        type: AuthActionTypes.GET_AUTHORIZE_TOKEN,
                        payload,
                    })
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch({
                        type: AuthActionTypes.GET_AUTHORIZE_TOKEN,
                        payload: null,
                    })
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const getPublicToken = () => {
    return (dispatch: Redux.Dispatch) => {
        const headers = APIServices.authenticationHeader()
        return new Promise((resolve, reject) => {
            axios
                .post(`${authUrl}/token`, {}, { headers })
                .then((response) => {
                    dispatch({
                        type: AuthActionTypes.GET_PUBLIC_TOKEN,
                        payload: response?.data?.accessToken,
                    })
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch({
                        type: AuthActionTypes.GET_PUBLIC_TOKEN,
                        payload: null,
                    })
                    reject(errors)
                })
        })
    }
}

const registerUser = (userInfo: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(setLoading(true) as any)
        const headers = APIServices.authenticationHeader()
        return new Promise((resolve, reject) => {
            axios
                .post(`${authUrl}/register`, userInfo, { headers })
                .then((response) => {
                    ToastServices.success('User created')
                    dispatch({
                        type: AuthActionTypes.SET_REGISTER,
                        payload: null,
                    })
                    dispatch(setRegister([]) as any)
                    dispatch(setLoading(false) as any)
                    resolve(response)
                })
                .catch((errors) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(setLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const login = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(setLoading(true) as any)
        const headers = APIServices.authenticationHeader()
        return new Promise((resolve, reject) => {
            axios
                .post(`${authUrl}/login`, payload, { headers })
                .then((response) => {
                    dispatch({
                        type: AuthActionTypes.LOGIN,
                        payload: response?.data,
                    })
                    dispatch(setRegister([]) as any)
                    dispatch(setLoading(false) as any)
                    resolve(response)
                })
                .catch((errors) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(setLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const logout = () => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({ type: AuthActionTypes.LOGOUT })
    }
}

const clearReground = (types: string[]) => {
    return (dispatch: Redux.Dispatch) => {
        const payload: any = []
        if (types.includes(EAuthReground.COUNTRIES)) {
            dispatch({
                type: AuthActionTypes.GET_COUNTRIES,
                payload,
            })
        }
        if (types.includes(EAuthReground.STATES)) {
            dispatch({
                type: AuthActionTypes.GET_STATES,
                payload,
            })
        }
        if (types.includes(EAuthReground.CITIES)) {
            dispatch({
                type: AuthActionTypes.GET_CITIES,
                payload,
            })
        }
        if (types.includes(EAuthReground.POB_COUNTRIES)) {
            dispatch({ type: AuthActionTypes.GET_POB_COUNTRIES, payload })
        }
        if (types.includes(EAuthReground.POB_STATES)) {
            dispatch({ type: AuthActionTypes.GET_POB_STATES, payload })
        }
        if (types.includes(EAuthReground.POB_CITIES)) {
            dispatch({ type: AuthActionTypes.GET_POB_CITIES, payload })
        }
        if (types.includes(EAuthReground.PR_COUNTRIES)) {
            dispatch({ type: AuthActionTypes.GET_PR_COUNTRIES, payload })
        }
        if (types.includes(EAuthReground.PR_STATES)) {
            dispatch({ type: AuthActionTypes.GET_PR_STATES, payload })
        }
        if (types.includes(EAuthReground.PR_CITIES)) {
            dispatch({ type: AuthActionTypes.GET_PR_CITIES, payload })
        }
    }
}

const setReground = (type: string, result: any) => {
    return (dispatch: Redux.Dispatch) => {
        switch (type) {
            case 'COUNTRY':
                if (result?.data) return
                dispatch({
                    type: AuthActionTypes.GET_COUNTRIES,
                    payload: result.map((item: MCountry) => new MCountry(item)),
                })
                break
            case 'STATE':
                if (result?.data) return
                dispatch({
                    type: AuthActionTypes.GET_STATES,
                    payload: result.map((item: MState) => new MState(item)),
                })
                break
            case 'CITY':
                if (result?.data) return

                dispatch({
                    type: AuthActionTypes.GET_CITIES,
                    payload: result.map((item: MCity) => new MCity(item)),
                })
                break
            case 'POB.states':
                if (result?.data) return

                dispatch({
                    type: AuthActionTypes.GET_POB_STATES,
                    payload: result.map((item: MState) => new MState(item)),
                })
                break
            case 'POB.cities':
                if (result?.data) return

                dispatch({
                    type: AuthActionTypes.GET_POB_CITIES,
                    payload: result.map((item: MCity) => new MCity(item)),
                })
                break
            case 'PR.countries':
                dispatch({
                    type: AuthActionTypes.GET_PR_COUNTRIES,
                    payload: result.map((item: MCountry) => new MCountry(item)),
                })
                break
            case 'PR.states':
                if (result?.data) return

                dispatch({
                    type: AuthActionTypes.GET_PR_STATES,
                    payload: result.map((item: MState) => new MState(item)),
                })
                break
            case 'PR.cities':
                if (result?.data) return

                dispatch({
                    type: AuthActionTypes.GET_PR_CITIES,
                    payload: result.map((item: MCity) => new MCountry(item)),
                })
                break

            // get reground by types (codes)
            case 'Normal':
                // eslint-disable-next-line no-case-declarations
                const {
                    city: nCity,
                    state: nState,
                    country: nCountry,
                } = result?.data
                dispatch({
                    type: AuthActionTypes.GET_COUNTRIES,
                    payload: nCountry?.map(
                        (item: MCountry) => new MCountry(item)
                    ),
                })
                dispatch({
                    type: AuthActionTypes.GET_STATES,
                    payload: nState?.map((item: MState) => new MState(item)),
                })
                dispatch({
                    type: AuthActionTypes.GET_CITIES,
                    payload: nCity?.map((item: MCity) => new MCity(item)),
                })
                break

            case 'POB':
                let pobCity
                let pobState
                if (result?.data) {
                    // const { city: pobCity, state: pobState } = result?.data
                    pobCity = result?.data?.city
                    pobState = result?.data?.state
                } else {
                    const pobCheckedType = result?.[0]?.type
                    if (pobCheckedType === 'STATE') {
                        pobState = result
                    } else {
                        pobCity = result
                    }
                }
                dispatch({
                    type: AuthActionTypes.GET_POB_STATES,
                    payload: pobState?.map((item: MState) => new MState(item)),
                })
                dispatch({
                    type: AuthActionTypes.GET_POB_CITIES,
                    payload: pobCity?.map((item: MCity) => new MCity(item)),
                })
                break

            case 'PR':
                let prCity
                let prState
                let prCountry
                // const {
                //     city: prCity,
                //     state: prState,
                //     country: prCountry,
                // } = result?.data
                if (result?.data) {
                    prCountry = result?.data?.country
                    prState = result?.data?.state
                    prCity = result?.data?.city
                } else {
                    const prCheckedType = result?.[0]?.type
                    if (prCheckedType === 'COUNTRY') {
                        prCountry = result
                    }
                    if (prCheckedType === 'STATE') {
                        prCountry = result
                    }
                    if (prCheckedType === 'CITY') {
                        prCountry = result
                    }
                }
                dispatch({
                    type: AuthActionTypes.GET_PR_COUNTRIES,
                    payload: prCountry?.map(
                        (item: MCountry) => new MCountry(item)
                    ),
                })
                dispatch({
                    type: AuthActionTypes.GET_PR_STATES,
                    payload: prState?.map((item: MState) => new MState(item)),
                })
                dispatch({
                    type: AuthActionTypes.GET_PR_CITIES,
                    payload: prCity?.map((item: MCity) => new MCountry(item)),
                })
                break
            default:
                break
        }
    }
}

const getReground = (type: string, parentCode: string, stepTwo?: string) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        // use this to remove Authorization field from the header request only this request
        // delete axios.defaults.headers.common.Authorization

        const token = getState()?.auth?.publicToken
        const status = 'ACTIVE'
        const params = parentCode
            ? { token, parentCode, status }
            : { token, status }
        axios
            .get(`${REGROUND}/${type}`, { params: { ...params, limit: 0 } })
            .then((response: AxiosResponse) => {
                const result = response?.data?.data
                if (!result?.length) return
                const checkType = stepTwo || result?.[0]?.type
                dispatch(setReground(checkType, result) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(setLoading(false) as any)
            })
    }
}

const getRegroundByType = (
    type: string,
    params: ICommonQuery,
    index?: number
) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .get(`${REGROUND}/types`, { params: { ...params, limit: 0 } })
                .then((response) => {
                    if (!index || index === 0)
                        dispatch(setReground(type, response) as any)
                    resolve({ response, index })
                })
                .catch((errors) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const setDynamicReground = (
    type: RegroundTypes,
    index: number | undefined,
    result: any
) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        if (index === undefined || index === null) return
        const existingData = getState()?.auth?.dynamicReground
        switch (type) {
            case 'COUNTRY':
                const tempCountries = result?.map(
                    (country: MCountry) => new MCountry(country)
                )
                return dispatch({
                    type: AuthActionTypes.GET_DYNAMIC_PR_COUNTRIES,
                    payload: tempCountries,
                })

            case 'STATE':
                const tempStates = _.cloneDeep(existingData?.states) || []
                tempStates[index] = result?.map(
                    (state: MState) => new MState(state)
                )
                return dispatch({
                    type: AuthActionTypes.GET_DYNAMIC_PR_STATES,
                    payload: tempStates,
                })
            case 'CITY':
                const tempCities = _.cloneDeep(existingData?.cities) || []
                tempCities[index] = result?.map(
                    (city: MCity) => new MCity(city)
                )
                return dispatch({
                    type: AuthActionTypes.GET_DYNAMIC_PR_CITIES,
                    payload: tempCities,
                })

            default:
                break
        }
    }
}

const clearDynamicReground = (
    types: Array<RegroundTypes>,
    index: number,
    deleteReground?: boolean
) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const existingData = getState()?.auth?.dynamicReground
        if (types?.includes('COUNTRY')) {
            const tempCountries = _.cloneDeep(existingData?.countries)
            if (deleteReground) {
                tempCountries?.splice(index, 1)
            } else {
                tempCountries[index] = []
            }
            dispatch({
                type: AuthActionTypes.GET_DYNAMIC_PR_COUNTRIES,
                payload: tempCountries,
            })
        }
        if (types?.includes('STATE')) {
            const tempStates = _.cloneDeep(existingData?.states) || []
            if (deleteReground) {
                tempStates?.splice(index, 1)
            } else {
                tempStates[index] = []
            }
            dispatch({
                type: AuthActionTypes.GET_DYNAMIC_PR_STATES,
                payload: tempStates,
            })
        }
        if (types?.includes('CITY')) {
            const tempCities = _.cloneDeep(existingData?.cities) || []
            if (deleteReground) {
                tempCities?.splice(index, 1)
            } else {
                tempCities[index] = []
            }
            dispatch({
                type: AuthActionTypes.GET_DYNAMIC_PR_CITIES,
                payload: tempCities,
            })
        }
    }
}

const getDynamicReground = (
    type: RegroundTypes,
    params: ICommonQuery,
    index: number | undefined
) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const token = getState()?.auth?.publicToken
        const status = 'ACTIVE'

        axios
            .get(`${REGROUND}/${type}`, {
                params: { status, token, limit: 0, ...params },
            })
            .then((response: AxiosResponse) => {
                const result = response?.data?.data
                dispatch(setDynamicReground(type, index, result) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
            })
    }
}

const validationUsername = (username: string) => {
    return () => {
        const headers = APIServices.authenticationHeader()

        return new Promise((resolve, reject) => {
            axios
                .post(`${authUrl}/check-username`, { username }, { headers })
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const AuthAction = {
    getAuthorization,
    setRegister,
    registerUser,
    login,
    logout,
    getPublicToken,
    setLoading,
    getReground,
    clearReground,
    getRegroundByType,
    getDynamicReground,
    setDynamicReground,
    clearDynamicReground,
    validationUsername,
}

export default AuthAction
